"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackVisibility = exports.scrollVertically = exports.scrollHorizontally = exports.scrollTo = void 0;
var gsap_1 = require("gsap");
var ScrollTrigger_1 = require("gsap/ScrollTrigger");
var ScrollToPlugin_1 = require("gsap/ScrollToPlugin");
gsap_1.gsap.registerPlugin(ScrollTrigger_1.ScrollTrigger, ScrollToPlugin_1.ScrollToPlugin);
// Assign GSAP to the global Window object.
window.gsap = gsap_1.gsap;
var initialiseGsapEntryAnimations = function () {
    var entryElements = Array.from(document.querySelectorAll('.entry'));
    if (!entryElements.length)
        return;
    entryElements.forEach(function (element) {
        gsap_1.gsap.to(element, {
            scrollTrigger: {
                start: 'top bottom',
                trigger: element,
                toggleClass: 'entry-active',
                once: true,
            },
        });
    });
};
// Utility method to scroll-smooth to any element.
var scrollTo = function (el, offset) {
    if (offset === void 0) { offset = 0; }
    gsap_1.gsap.to(window, {
        duration: 1,
        ease: 'power2',
        scrollTo: {
            y: el,
            offsetY: offset,
        },
    });
};
exports.scrollTo = scrollTo;
var scrollHorizontally = function (container, el, offset, duration) {
    if (offset === void 0) { offset = 0; }
    if (duration === void 0) { duration = 1; }
    gsap_1.gsap.to(container, {
        duration: duration,
        ease: 'power2',
        scrollTo: {
            x: el,
            offsetX: offset,
        },
    });
};
exports.scrollHorizontally = scrollHorizontally;
var scrollVertically = function (container, el, offset, duration) {
    if (offset === void 0) { offset = 0; }
    if (duration === void 0) { duration = 1; }
    gsap_1.gsap.to(container, {
        duration: duration,
        ease: 'power2',
        scrollTo: {
            y: el,
            offsetY: offset,
        },
    });
};
exports.scrollVertically = scrollVertically;
// Utility method to be used for tracking visibility of modules.
var trackVisibility = function (element, cb) {
    gsap_1.gsap.to(element, {
        scrollTrigger: {
            start: 'top bottom',
            trigger: element,
            once: true,
            onEnter: function () {
                if (typeof cb === 'function') {
                    cb();
                }
            },
        },
    });
};
exports.trackVisibility = trackVisibility;
document.addEventListener('alpine:init', function () {
    initialiseGsapEntryAnimations();
});
